import Divider from 'LuxKit/Divider'
import LineCoinsIcon from 'LuxKit/Icons/line/LineCoinsIcon'
import LineGiftIcon from 'LuxKit/Icons/line/LineGiftIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'

function SocieteRewardsBenefits() {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={16}>
      <Group direction="vertical" gap={8}>
        <Heading variant="heading4">
          {intl.formatMessage({
            id: '2KonW4-k9H54Tbj8MO6g',
            defaultMessage: 'Earn rewards every time you book',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: '5GdSu6dwOyaNintIqSXo',
            defaultMessage: 'Link your Société account and start turning every dollar you book into points, perks and extra commission.',
          })}
        </BodyText>
      </Group>

      <Group direction="horizontal" gap={16} horizontalAlign="start">
        <LineCoinsIcon colour="light-foreground-alt" size="M" />
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: 'GThXfHw4CG4VJas4GmVr',
              defaultMessage: 'Points on every dollar you spend',
            })}
          </BodyText>
          <BodyText variant="medium">
            {intl.formatMessage({
              id: 'KET7TlqBNOU55vNrkEMc',
              defaultMessage: 'Every booking you make earns Société points automatically — no opt-ins, no minimum spend.',
            })}
          </BodyText>
        </Group>
      </Group>

      <Group direction="horizontal" gap={16} horizontalAlign="start">
        <LineStarIcon colour="light-foreground-alt" size="M" />
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: 'rEqZD_Yk0tWDxYZ5KK1j',
              defaultMessage: 'Bonus points for hitting goals',
            })}
          </BodyText>
          <BodyText variant="medium">
            {intl.formatMessage({
              id: 'kZ6cdlRUbUwI__w9umrI',
              defaultMessage: 'Complete challenges and join campaigns to stack bonus points on top of your everyday earnings.',
            })}
          </BodyText>
        </Group>
      </Group>

      <Group direction="horizontal" gap={16} horizontalAlign="start">
        <LineGiftIcon colour="light-foreground-alt" size="M" />
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: 'RACaTiglYFyYmcUEU5Lf',
              defaultMessage: 'Redeem your way',
            })}
          </BodyText>
          <BodyText variant="medium">
            {intl.formatMessage({
              id: 'FyvnzNPIunxwxq3dik75',
              defaultMessage: 'Use points to discount client trips, shop in LE Shop, or cash out as bonus commission — your choice.',
            })}
          </BodyText>
        </Group>
      </Group>
      <Divider kind="primary" />
    </Group>
  )
}

export default SocieteRewardsBenefits
